// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cpv-page {
  --cpv-bg: #0b0f19;
  --cpv-slate: #121826;
  --cpv-text: #f8fafc;
  --cpv-muted: #94a3b8;
  --cpv-border: rgba(255, 255, 255, 0.08);
  --cpv-glass: rgba(15, 23, 42, 0.72);
  --cpv-primary: var(--brand-primary, #0877bc);
  --cpv-done: #34d399;
  --cpv-wait: #fbbf24;
  --cpv-fail: #f87171;
  box-sizing: border-box;
  min-height: 100vh;
  min-height: 100dvh;
  /* Bottom room so the last card scrolls clear of the floating assistant button. */
  padding: calc(0.75rem + env(safe-area-inset-top, 0px))
    max(1rem, env(safe-area-inset-right, 0px))
    calc(170px + env(safe-area-inset-bottom, 0px))
    max(1rem, env(safe-area-inset-left, 0px));
  background:
    radial-gradient(1100px 520px at 8% -18%, color-mix(in srgb, var(--cpv-primary) 28%, transparent), transparent 58%),
    var(--cpv-bg);
  color: var(--cpv-text);
  font-family: Outfit, Inter, var(--brand-font, sans-serif);
}

.cpv-page--light {
  --cpv-bg: #f3f5f8;
  --cpv-slate: #ffffff;
  --cpv-text: #0f172a;
  --cpv-muted: #475569;
  --cpv-border: rgba(15, 23, 42, 0.1);
  --cpv-glass: rgba(255, 255, 255, 0.86);
  --cpv-done: #047857;
  --cpv-wait: #b45309;
  --cpv-fail: #dc2626;
}

.cpv-page *,
.cpv-player * {
  box-sizing: border-box;
}

.cpv-page button,
.cpv-player button {
  font: inherit;
}

.cpv-page__inner {
  max-width: 560px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.cpv-head {
  display: flex;
  align-items: center;
  gap: 10px;
}

.cpv-head__text {
  min-width: 0;
}

.cpv-head__title {
  margin: 0;
  font-size: 1.35rem;
  font-weight: 800;
  letter-spacing: -0.01em;
}

.cpv-head__meta {
  margin: 2px 0 0;
  color: var(--cpv-muted);
  font-size: 0.85rem;
  font-variant-numeric: tabular-nums;
}

.cpv-icon-btn {
  flex: 0 0 auto;
  width: 40px;
  height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  border: 1px solid var(--cpv-border);
  background: var(--cpv-glass);
  color: inherit;
  cursor: pointer;
}

.cpv-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 38px;
  padding: 0 14px;
  border-radius: 999px;
  border: 1px solid transparent;
  font-size: 0.86rem;
  font-weight: 700;
  cursor: pointer;
  color: inherit;
  background: transparent;
  white-space: nowrap;
}

.cpv-btn:disabled {
  opacity: 0.45;
  cursor: default;
}

.cpv-btn--primary {
  background: var(--cpv-primary);
  color: #fff;
}

.cpv-btn--ghost {
  border-color: var(--cpv-border);
  background: var(--cpv-glass);
}

.cpv-btn--danger {
  color: var(--cpv-fail);
}

.cpv-icon-btn:focus-visible,
.cpv-btn:focus-visible,
.cpv-mode:focus-visible,
.cpv-rec__thumb:focus-visible,
.cpv-strip__hit:focus-visible,
.cpv-link:focus-visible {
  outline: 2px solid var(--cpv-primary);
  outline-offset: 2px;
}

.cpv-sync {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 14px;
  border-radius: 18px;
  border: 1px solid var(--cpv-border);
  background: var(--cpv-glass);
}

.cpv-sync__top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.cpv-net {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 0.85rem;
  font-weight: 700;
  color: var(--cpv-muted);
}

.cpv-net--wifi {
  color: var(--cpv-done);
}

.cpv-net--cellular {
  color: var(--cpv-wait);
}

.cpv-net--none {
  color: var(--cpv-fail);
}

.cpv-progress {
  height: 4px;
  border-radius: 999px;
  background: var(--cpv-border);
  overflow: hidden;
}

.cpv-progress > span {
  display: block;
  height: 100%;
  background: var(--cpv-primary);
  transition: width 0.3s ease;
}

.cpv-sync__status {
  margin: 0;
  font-size: 0.86rem;
  font-weight: 600;
}

.cpv-note {
  margin: 0;
  font-size: 0.8rem;
  line-height: 1.4;
  color: var(--cpv-muted);
}

.cpv-modes {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 4px;
  padding: 4px;
  border-radius: 14px;
  background: color-mix(in srgb, var(--cpv-text) 6%, transparent);
}

.cpv-mode {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 3px;
  min-height: 48px;
  padding: 6px 4px;
  text-align: center;
  line-height: 1.15;
  border: 0;
  border-radius: 10px;
  background: transparent;
  color: var(--cpv-muted);
  font-size: 0.8rem;
  font-weight: 700;
  cursor: pointer;
}

.cpv-mode.is-on {
  background: var(--cpv-slate);
  color: var(--cpv-text);
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.18);
}

.cpv-match {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.cpv-match__head {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 10px;
  padding: 6px 2px 0;
}

.cpv-match__text {
  min-width: 0;
}

.cpv-match__title {
  margin: 0;
  font-size: 1rem;
  font-weight: 800;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cpv-match__date {
  margin: 1px 0 0;
  font-size: 0.78rem;
  color: var(--cpv-muted);
}

.cpv-link {
  flex: 0 0 auto;
  font-size: 0.82rem;
  font-weight: 700;
  color: var(--cpv-primary);
  text-decoration: none;
}

.cpv-recs {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.cpv-rec {
  display: grid;
  grid-template-columns: 112px minmax(0, 1fr);
  gap: 10px 12px;
  padding: 12px;
  border-radius: 16px;
  border: 1px solid var(--cpv-border);
  background: var(--cpv-glass);
}

.cpv-rec.is-done {
  opacity: 0.72;
}

.cpv-rec__thumb {
  position: relative;
  width: 112px;
  aspect-ratio: 16 / 9;
  padding: 0;
  border: 0;
  border-radius: 10px;
  overflow: hidden;
  background: #000;
  color: var(--cpv-muted);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.cpv-rec__thumb:disabled {
  cursor: default;
}

.cpv-rec__thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.cpv-rec__play {
  position: absolute;
  inset: auto 6px 6px auto;
  width: 28px;
  height: 28px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.55);
  color: #fff;
}

.cpv-rec__body {
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 2px;
}

.cpv-rec__title {
  margin: 0;
  font-size: 0.95rem;
  font-weight: 800;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cpv-rec__meta {
  margin: 0;
  font-size: 0.78rem;
  color: var(--cpv-muted);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cpv-rec__meta--num {
  font-variant-numeric: tabular-nums;
}

/* One cell per saved minute: the recording's upload, piece by piece. */
.cpv-strip {
  grid-column: 1 / -1;
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 3px;
}

.cpv-strip__cell {
  --cpv-fill: 0%;
  position: relative;
  flex: 1 1;
  min-width: 8px;
  max-width: 32px;
  height: 12px;
  border-radius: 3px;
  background: color-mix(in srgb, var(--cpv-text) 14%, transparent);
  overflow: hidden;
}

.cpv-strip__cell.is-active {
  background:
    linear-gradient(90deg, var(--cpv-primary) var(--cpv-fill), transparent var(--cpv-fill)),
    color-mix(in srgb, var(--cpv-primary) 22%, transparent);
  animation: cpv-cell-pulse 1.4s ease-in-out infinite;
}

.cpv-strip__cell.is-done {
  background: var(--cpv-done);
}

.cpv-strip__cell.is-failed {
  background: var(--cpv-fail);
}

.cpv-strip__hit {
  position: absolute;
  inset: -6px 0;
  width: 100%;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
}

@keyframes cpv-cell-pulse {
  50% {
    opacity: 0.7;
  }
}

@media (prefers-reduced-motion: reduce) {
  .cpv-strip__cell.is-active {
    animation: none;
  }

  .cpv-progress > span {
    transition: none;
  }
}

.cpv-rec__status {
  grid-column: 1 / -1;
  margin: -2px 0 0;
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.8rem;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
}

.cpv-rec__status--done {
  color: var(--cpv-done);
}

.cpv-rec__status--error {
  color: var(--cpv-fail);
  align-items: flex-start;
}

.cpv-rec__status--error svg {
  flex: 0 0 auto;
  margin-top: 2px;
}

.cpv-rec__actions {
  grid-column: 1 / -1;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.cpv-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 36px 16px;
  text-align: center;
  color: var(--cpv-muted);
}

.cpv-empty__title {
  margin: 4px 0 0;
  font-size: 1rem;
  font-weight: 800;
  color: var(--cpv-text);
}

.cpv-empty__text {
  margin: 0;
  max-width: 34ch;
  font-size: 0.86rem;
  line-height: 1.45;
  color: var(--cpv-muted);
}

.cpv-player {
  position: fixed;
  inset: 0;
  /* Above the floating assistant button (1300). */
  z-index: 1400;
  display: flex;
  flex-direction: column;
  background: #000;
  color: #f8fafc;
  font-family: Outfit, Inter, var(--brand-font, sans-serif);
  padding: env(safe-area-inset-top, 0px) env(safe-area-inset-right, 0px)
    env(safe-area-inset-bottom, 0px) env(safe-area-inset-left, 0px);
}

.cpv-player .cpv-icon-btn,
.cpv-player .cpv-btn--ghost {
  border-color: rgba(255, 255, 255, 0.16);
  background: rgba(255, 255, 255, 0.08);
}

.cpv-player__bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 12px;
}

.cpv-player__text {
  min-width: 0;
}

.cpv-player__title {
  margin: 0;
  font-weight: 800;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cpv-player__meta {
  margin: 1px 0 0;
  font-size: 0.8rem;
  color: #94a3b8;
  font-variant-numeric: tabular-nums;
}

.cpv-player__stage {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cpv-player__stage video {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: #000;
}

.cpv-player__msg {
  margin: 0;
  padding: 0 24px;
  text-align: center;
  color: #94a3b8;
}

.cpv-player__nav {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 12px 14px;
}

.cpv-player__nav .cpv-btn {
  color: #f8fafc;
}
`, "",{"version":3,"sources":["webpack://./src/pages/championship/ChampionshipPhoneVideosPage.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,uCAAuC;EACvC,mCAAmC;EACnC,4CAA4C;EAC5C,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,iFAAiF;EACjF;;;6CAG2C;EAC3C;;iBAEe;EACf,sBAAsB;EACtB,yDAAyD;AAC3D;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,mCAAmC;EACnC,sCAAsC;EACtC,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,mCAAmC;EACnC,4BAA4B;EAC5B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;;;;;EAME,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,+DAA+D;AACjE;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,oBAAoB;EACpB,UAAU;EACV,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;AACpC;;AAEA,uEAAuE;AACvE;EACE,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAW;EACX,cAAc;EACd,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,gEAAgE;EAChE,gBAAgB;AAClB;;AAEA;EACE;;2DAEyD;EACzD,mDAAmD;AACrD;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,gDAAgD;EAChD,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,yDAAyD;EACzD;mEACiE;AACnE;;AAEA;;EAEE,uCAAuC;EACvC,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".cpv-page {\n  --cpv-bg: #0b0f19;\n  --cpv-slate: #121826;\n  --cpv-text: #f8fafc;\n  --cpv-muted: #94a3b8;\n  --cpv-border: rgba(255, 255, 255, 0.08);\n  --cpv-glass: rgba(15, 23, 42, 0.72);\n  --cpv-primary: var(--brand-primary, #0877bc);\n  --cpv-done: #34d399;\n  --cpv-wait: #fbbf24;\n  --cpv-fail: #f87171;\n  box-sizing: border-box;\n  min-height: 100vh;\n  min-height: 100dvh;\n  /* Bottom room so the last card scrolls clear of the floating assistant button. */\n  padding: calc(0.75rem + env(safe-area-inset-top, 0px))\n    max(1rem, env(safe-area-inset-right, 0px))\n    calc(170px + env(safe-area-inset-bottom, 0px))\n    max(1rem, env(safe-area-inset-left, 0px));\n  background:\n    radial-gradient(1100px 520px at 8% -18%, color-mix(in srgb, var(--cpv-primary) 28%, transparent), transparent 58%),\n    var(--cpv-bg);\n  color: var(--cpv-text);\n  font-family: Outfit, Inter, var(--brand-font, sans-serif);\n}\n\n.cpv-page--light {\n  --cpv-bg: #f3f5f8;\n  --cpv-slate: #ffffff;\n  --cpv-text: #0f172a;\n  --cpv-muted: #475569;\n  --cpv-border: rgba(15, 23, 42, 0.1);\n  --cpv-glass: rgba(255, 255, 255, 0.86);\n  --cpv-done: #047857;\n  --cpv-wait: #b45309;\n  --cpv-fail: #dc2626;\n}\n\n.cpv-page *,\n.cpv-player * {\n  box-sizing: border-box;\n}\n\n.cpv-page button,\n.cpv-player button {\n  font: inherit;\n}\n\n.cpv-page__inner {\n  max-width: 560px;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.cpv-head {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.cpv-head__text {\n  min-width: 0;\n}\n\n.cpv-head__title {\n  margin: 0;\n  font-size: 1.35rem;\n  font-weight: 800;\n  letter-spacing: -0.01em;\n}\n\n.cpv-head__meta {\n  margin: 2px 0 0;\n  color: var(--cpv-muted);\n  font-size: 0.85rem;\n  font-variant-numeric: tabular-nums;\n}\n\n.cpv-icon-btn {\n  flex: 0 0 auto;\n  width: 40px;\n  height: 40px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 999px;\n  border: 1px solid var(--cpv-border);\n  background: var(--cpv-glass);\n  color: inherit;\n  cursor: pointer;\n}\n\n.cpv-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  min-height: 38px;\n  padding: 0 14px;\n  border-radius: 999px;\n  border: 1px solid transparent;\n  font-size: 0.86rem;\n  font-weight: 700;\n  cursor: pointer;\n  color: inherit;\n  background: transparent;\n  white-space: nowrap;\n}\n\n.cpv-btn:disabled {\n  opacity: 0.45;\n  cursor: default;\n}\n\n.cpv-btn--primary {\n  background: var(--cpv-primary);\n  color: #fff;\n}\n\n.cpv-btn--ghost {\n  border-color: var(--cpv-border);\n  background: var(--cpv-glass);\n}\n\n.cpv-btn--danger {\n  color: var(--cpv-fail);\n}\n\n.cpv-icon-btn:focus-visible,\n.cpv-btn:focus-visible,\n.cpv-mode:focus-visible,\n.cpv-rec__thumb:focus-visible,\n.cpv-strip__hit:focus-visible,\n.cpv-link:focus-visible {\n  outline: 2px solid var(--cpv-primary);\n  outline-offset: 2px;\n}\n\n.cpv-sync {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding: 14px;\n  border-radius: 18px;\n  border: 1px solid var(--cpv-border);\n  background: var(--cpv-glass);\n}\n\n.cpv-sync__top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.cpv-net {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 0.85rem;\n  font-weight: 700;\n  color: var(--cpv-muted);\n}\n\n.cpv-net--wifi {\n  color: var(--cpv-done);\n}\n\n.cpv-net--cellular {\n  color: var(--cpv-wait);\n}\n\n.cpv-net--none {\n  color: var(--cpv-fail);\n}\n\n.cpv-progress {\n  height: 4px;\n  border-radius: 999px;\n  background: var(--cpv-border);\n  overflow: hidden;\n}\n\n.cpv-progress > span {\n  display: block;\n  height: 100%;\n  background: var(--cpv-primary);\n  transition: width 0.3s ease;\n}\n\n.cpv-sync__status {\n  margin: 0;\n  font-size: 0.86rem;\n  font-weight: 600;\n}\n\n.cpv-note {\n  margin: 0;\n  font-size: 0.8rem;\n  line-height: 1.4;\n  color: var(--cpv-muted);\n}\n\n.cpv-modes {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 4px;\n  padding: 4px;\n  border-radius: 14px;\n  background: color-mix(in srgb, var(--cpv-text) 6%, transparent);\n}\n\n.cpv-mode {\n  display: inline-flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 3px;\n  min-height: 48px;\n  padding: 6px 4px;\n  text-align: center;\n  line-height: 1.15;\n  border: 0;\n  border-radius: 10px;\n  background: transparent;\n  color: var(--cpv-muted);\n  font-size: 0.8rem;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.cpv-mode.is-on {\n  background: var(--cpv-slate);\n  color: var(--cpv-text);\n  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.18);\n}\n\n.cpv-match {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.cpv-match__head {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 10px;\n  padding: 6px 2px 0;\n}\n\n.cpv-match__text {\n  min-width: 0;\n}\n\n.cpv-match__title {\n  margin: 0;\n  font-size: 1rem;\n  font-weight: 800;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.cpv-match__date {\n  margin: 1px 0 0;\n  font-size: 0.78rem;\n  color: var(--cpv-muted);\n}\n\n.cpv-link {\n  flex: 0 0 auto;\n  font-size: 0.82rem;\n  font-weight: 700;\n  color: var(--cpv-primary);\n  text-decoration: none;\n}\n\n.cpv-recs {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.cpv-rec {\n  display: grid;\n  grid-template-columns: 112px minmax(0, 1fr);\n  gap: 10px 12px;\n  padding: 12px;\n  border-radius: 16px;\n  border: 1px solid var(--cpv-border);\n  background: var(--cpv-glass);\n}\n\n.cpv-rec.is-done {\n  opacity: 0.72;\n}\n\n.cpv-rec__thumb {\n  position: relative;\n  width: 112px;\n  aspect-ratio: 16 / 9;\n  padding: 0;\n  border: 0;\n  border-radius: 10px;\n  overflow: hidden;\n  background: #000;\n  color: var(--cpv-muted);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\n.cpv-rec__thumb:disabled {\n  cursor: default;\n}\n\n.cpv-rec__thumb img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.cpv-rec__play {\n  position: absolute;\n  inset: auto 6px 6px auto;\n  width: 28px;\n  height: 28px;\n  border-radius: 999px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(0, 0, 0, 0.55);\n  color: #fff;\n}\n\n.cpv-rec__body {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 2px;\n}\n\n.cpv-rec__title {\n  margin: 0;\n  font-size: 0.95rem;\n  font-weight: 800;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.cpv-rec__meta {\n  margin: 0;\n  font-size: 0.78rem;\n  color: var(--cpv-muted);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.cpv-rec__meta--num {\n  font-variant-numeric: tabular-nums;\n}\n\n/* One cell per saved minute: the recording's upload, piece by piece. */\n.cpv-strip {\n  grid-column: 1 / -1;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 3px;\n}\n\n.cpv-strip__cell {\n  --cpv-fill: 0%;\n  position: relative;\n  flex: 1 1 0;\n  min-width: 8px;\n  max-width: 32px;\n  height: 12px;\n  border-radius: 3px;\n  background: color-mix(in srgb, var(--cpv-text) 14%, transparent);\n  overflow: hidden;\n}\n\n.cpv-strip__cell.is-active {\n  background:\n    linear-gradient(90deg, var(--cpv-primary) var(--cpv-fill), transparent var(--cpv-fill)),\n    color-mix(in srgb, var(--cpv-primary) 22%, transparent);\n  animation: cpv-cell-pulse 1.4s ease-in-out infinite;\n}\n\n.cpv-strip__cell.is-done {\n  background: var(--cpv-done);\n}\n\n.cpv-strip__cell.is-failed {\n  background: var(--cpv-fail);\n}\n\n.cpv-strip__hit {\n  position: absolute;\n  inset: -6px 0;\n  width: 100%;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  cursor: pointer;\n}\n\n@keyframes cpv-cell-pulse {\n  50% {\n    opacity: 0.7;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .cpv-strip__cell.is-active {\n    animation: none;\n  }\n\n  .cpv-progress > span {\n    transition: none;\n  }\n}\n\n.cpv-rec__status {\n  grid-column: 1 / -1;\n  margin: -2px 0 0;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 0.8rem;\n  font-weight: 600;\n  font-variant-numeric: tabular-nums;\n}\n\n.cpv-rec__status--done {\n  color: var(--cpv-done);\n}\n\n.cpv-rec__status--error {\n  color: var(--cpv-fail);\n  align-items: flex-start;\n}\n\n.cpv-rec__status--error svg {\n  flex: 0 0 auto;\n  margin-top: 2px;\n}\n\n.cpv-rec__actions {\n  grid-column: 1 / -1;\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n}\n\n.cpv-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n  padding: 36px 16px;\n  text-align: center;\n  color: var(--cpv-muted);\n}\n\n.cpv-empty__title {\n  margin: 4px 0 0;\n  font-size: 1rem;\n  font-weight: 800;\n  color: var(--cpv-text);\n}\n\n.cpv-empty__text {\n  margin: 0;\n  max-width: 34ch;\n  font-size: 0.86rem;\n  line-height: 1.45;\n  color: var(--cpv-muted);\n}\n\n.cpv-player {\n  position: fixed;\n  inset: 0;\n  /* Above the floating assistant button (1300). */\n  z-index: 1400;\n  display: flex;\n  flex-direction: column;\n  background: #000;\n  color: #f8fafc;\n  font-family: Outfit, Inter, var(--brand-font, sans-serif);\n  padding: env(safe-area-inset-top, 0px) env(safe-area-inset-right, 0px)\n    env(safe-area-inset-bottom, 0px) env(safe-area-inset-left, 0px);\n}\n\n.cpv-player .cpv-icon-btn,\n.cpv-player .cpv-btn--ghost {\n  border-color: rgba(255, 255, 255, 0.16);\n  background: rgba(255, 255, 255, 0.08);\n}\n\n.cpv-player__bar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 10px 12px;\n}\n\n.cpv-player__text {\n  min-width: 0;\n}\n\n.cpv-player__title {\n  margin: 0;\n  font-weight: 800;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.cpv-player__meta {\n  margin: 1px 0 0;\n  font-size: 0.8rem;\n  color: #94a3b8;\n  font-variant-numeric: tabular-nums;\n}\n\n.cpv-player__stage {\n  flex: 1 1 auto;\n  min-height: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.cpv-player__stage video {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  background: #000;\n}\n\n.cpv-player__msg {\n  margin: 0;\n  padding: 0 24px;\n  text-align: center;\n  color: #94a3b8;\n}\n\n.cpv-player__nav {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 10px 12px 14px;\n}\n\n.cpv-player__nav .cpv-btn {\n  color: #f8fafc;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
